import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';

export const DrawerList = [
  {
    name: 'Home',
    path: '/home',
    icon: <HomeIcon />,
  },
  {
    name: 'Sign out',
    path: '/dashboard',
    icon: <LogoutIcon />,
  },
];
